import { makeGlobalApiRequest } from "../../lib/globalApi";
import { UsageResponse } from "./types";

// Mock data kept for reference (no longer used)
const MOCK_USAGE_RESPONSE: UsageResponse = {
  usage: {
    selected_month: "2026-05",
    monthly_credit_allowance: 5,
    rollover_credits_in: 0.18,
    available_credits: 5.18,
    total_credits_consumed: 0.85,
    credits_remaining: 4.33,
    projected_rollover_out: 4.15,
    usage_by_model_core: {
      "align-20260109": { requests: 3200, tokens: 580000, credits: 0.58 },
      "align-lightning-20251127": { requests: 2000, tokens: 200000, credits: 0.2 },
      "align-lightning-20250731": { requests: 800, tokens: 140000, credits: 0.07 },
    },
    daily_consumption: [],
    previous_month: "2026-04",
    previous_month_consumed: 0.67,
    previous_month_consumed_to_same_day: 0.65,
    total_current_request_count: 6000,
    total_current_token_count: 850000,
    caching: {
      cached_tokens: 0,
      cacheable_tokens: 0,
      cached_evaluations: 0,
      total_evaluations: 0,
      by_model_core: {},
    },
  },
  quota_reset_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(), // 7 days from now
};

export const fetchUsageInfo = async (month?: string): Promise<UsageResponse> => {
  try {
    const path = month
      ? `/api/v1/usage?month=${encodeURIComponent(month)}`
      : "/api/v1/usage";
    // Usage aggregation lives in the global-api service (see lib/globalApi).
    const response = await makeGlobalApiRequest({
      method: "GET",
      path,
    });

    return response as UsageResponse;
  } catch (error: any) {
    // Handle specific error cases
    if (error.response) {
      const status = error.response.status;
      const message = error.response.data?.detail || error.message;

      if (status === 401) {
        throw new Error("Authentication required. Please log in.");
      } else if (status === 403) {
        throw new Error(message || "You don't have permission to view usage information.");
      } else {
        throw new Error(message || "Failed to fetch usage information");
      }
    }

    // Network or other errors
    throw new Error("Failed to fetch usage information. Please try again.");
  }
};
